export default "__VITE_ASSET__ClYrKD16__"